/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { FC, Children } from 'react';
import { LinkStyled } from './Link.styled';
import { LinkProps } from '@types';
import { logUserEvent } from '@analytics/amplifyLogging';
import { v4 } from 'uuid';
import { config } from '../../config';

const Link: FC<LinkProps> = React.forwardRef(({ href, onClick, ...props }, ref) => {
    const handleClick = () => {
        if (props?.eventAttributes) {
            const attributes = {
                action: props.eventAttributes?.action,
                description: props.eventAttributes?.description,
                type: props.eventAttributes?.type,
                loanNumber: props.eventAttributes?.loanNumber
            };
            logUserEvent(attributes);
        }
        onClick();
    };
    return (
        <LinkStyled href={href} {...props} onClick={handleClick}>
            <>
                {Children.map(props.children, c => {
                    return c;
                })}
            </>
        </LinkStyled>
    );
});
export default Link;
